import { ResponsivePictureLayout } from '@news-mono/component-library'
import { layout } from '../../../App.routing'
import { billboardLeaderboardMrec } from '../../ad-units'

export const sportCricketCurationId = 'cricket'

export const getCricketCurationSieraComponent = () => {
    return layout.component({
        type: 'sierra',
        props: {
            verticalSpacing: 'gridGap',
            fixedRatios: ['16:9'],
            heroImageLayout: ResponsivePictureLayout.ObjectFitContain,
            cardOrientation: {
                type: 'Landscape-Portrait',
                maxBreakpoint: 'md',
            },
            cardLayout: ['hero', 'teaser-xsVisible-mdHidden-Image'],

            dataDefinitionArgs: {
                type: 'curation',
                name: sportCricketCurationId,
                offset: 0,
                pageSize: 2,
            },
        },
    })
}
export const getCricketCurationLimaComponent = () => {
    return layout.component({
        type: 'lima',
        props: {
            verticalSpacing: 'xl',
            fontScale: 1.2,
            fixedRatios: ['16:9'],
            hasBackground: true,
            initialColumns: 1,
            intermediateColumns: 2,
            finalColumns: 4,
            teaserMode: 'visible',
            cardOrientation: { type: 'Landscape-Portrait' },

            dataDefinitionArgs: {
                type: 'curation',
                name: sportCricketCurationId,
                offset: 2,
                pageSize: 4,
            },
        },
    })
}

export const getCricketChildTopicComponents = () => [
    layout.component({
        type: 'lima',
        props: {
            verticalSpacing: 'xl',
            fontScale: 1.2,
            fixedRatios: ['16:9'],
            hasBackground: true,
            teaserMode: 'hidden',
            initialColumns: 1,
            intermediateColumns: 2,
            finalColumns: 4,
            cardOrientation: { type: 'Landscape-Portrait' },

            sectionHeader: {
                heading: 'Australian Cricket Team',
                headingUrl: '/sport/australian-cricket-team',
            },
            dataDefinitionArgs: {
                type: 'listing',
                topics: ['sport/australian-cricket-team'],
                includeSubTopics: false,
                paging: {
                    page: 1,
                    pageSize: 4,
                },
            },
        },
    }),
    layout.component({
        type: 'lima',
        props: {
            verticalSpacing: 'xl',
            fontScale: 1.2,
            fixedRatios: ['16:9'],
            hasBackground: true,
            teaserMode: 'hidden',
            initialColumns: 1,
            intermediateColumns: 2,
            finalColumns: 4,
            cardOrientation: { type: 'Landscape-Portrait' },

            sectionHeader: {
                heading: 'Big Bash League',
                headingUrl: '/sport/big-bash-league',
            },
            dataDefinitionArgs: {
                type: 'listing',
                topics: ['sport/big-bash-league'],
                includeSubTopics: false,
                paging: {
                    page: 1,
                    pageSize: 4,
                },
            },
        },
    }),
    ...billboardLeaderboardMrec('one'),
    layout.component({
        type: 'lima',
        props: {
            verticalSpacing: 'xl',
            fontScale: 1.2,
            fixedRatios: ['16:9'],
            hasBackground: true,
            teaserMode: 'hidden',
            initialColumns: 1,
            intermediateColumns: 2,
            finalColumns: 4,
            cardOrientation: { type: 'Landscape-Portrait' },

            sectionHeader: {
                heading: 'Perth Scorchers',
                headingUrl: '/sport/perth-scorchers',
            },
            dataDefinitionArgs: {
                type: 'listing',
                topics: ['sport/perth-scorchers'],
                includeSubTopics: false,
                paging: {
                    page: 1,
                    pageSize: 4,
                },
            },
        },
    }),
    layout.component({
        type: 'lima',
        props: {
            verticalSpacing: 'xl',
            fontScale: 1.2,
            fixedRatios: ['16:9'],
            hasBackground: true,
            teaserMode: 'hidden',
            initialColumns: 1,
            intermediateColumns: 2,
            finalColumns: 4,
            cardOrientation: { type: 'Landscape-Portrait' },

            sectionHeader: {
                heading: 'Women’s Cricket',
                headingUrl: '/sport/womens-cricket',
            },
            dataDefinitionArgs: {
                type: 'listing',
                topics: ['sport/womens-cricket'],
                includeSubTopics: false,
                paging: {
                    page: 1,
                    pageSize: 4,
                },
            },
        },
    }),
    ...billboardLeaderboardMrec('two'),
    layout.component({
        type: 'lima',
        props: {
            verticalSpacing: 'xl',
            fontScale: 1.2,
            fixedRatios: ['16:9'],
            hasBackground: true,
            teaserMode: 'hidden',
            initialColumns: 1,
            intermediateColumns: 2,
            finalColumns: 4,
            loadMoreEnabled: true,
            cardOrientation: { type: 'Landscape-Portrait' },

            sectionHeader: {
                heading: 'Latest',
            },
            dataDefinitionArgs: {
                type: 'listing',
                topics: ['sport/cricket'],
                includeSubTopics: false,
                paging: {
                    page: 1,
                    pageSize: 8,
                },
            },
        },
    }),
]

export const getDefaultCricketLayout = () => {
    return [
        getCricketCurationSieraComponent(),
        getCricketCurationLimaComponent(),
        ...getCricketChildTopicComponents(),
    ]
}
